export default "__VITE_ASSET__ChCMMYRC__"